import type { DeferredSpawn } from '../types';
import { registerWeapon, lookupWeapon, createProjectile } from './registry';
import { SMALL_CRATER } from '../terrain/crater-shapes';
import { random } from '../terrain/rng';

const BUCKSHOT = registerWeapon({
  id: 'buckshot',
  name: 'Buckshot',
  description: 'Shotgun blast. 5 fragments in a tight cone. Devastating up close.',
  tier: 'UNCOMMON',
  rarity: 'uncommon',
  projectileRadius: 4,
  projectileSpeed: 0.55,
  color: 0xff8844,
  gravity: 0.15,
  bounces: 0,
  bounceEnergyRetention: 0.85,
  damage: 0,
  blastRadius: 20,
  knockbackMult: 0.01,
  knockbackRadius: 0.5,
  shakeIntensity: 4.0,
  particleScale: 0.3,
  craterShape: SMALL_CRATER,
  onTick(proj, state, _fx) {
    // Immediately burst into fragments on first frame
    if (!proj.behaviorState.fired) {
      proj.behaviorState.fired = 1;
      const fragWeapon = lookupWeapon('buckshot_fragment');
      const baseAngle = Math.atan2(proj.vy, proj.vx);
      const speed = Math.sqrt(proj.vx * proj.vx + proj.vy * proj.vy);
      const spawns: DeferredSpawn[] = [];
      for (let i = 0; i < 5; i++) {
        const angle = baseAngle + (i - 2) * 0.12; // tight ±0.24 rad cone
        const fragSpeed = speed * (0.9 + random() * 0.2);
        spawns.push({
          spawnFrame: state.frameCount,
          spawned: false,
          projectile: createProjectile(
            fragWeapon, proj.x, proj.y,
            Math.cos(angle) * fragSpeed,
            Math.sin(angle) * fragSpeed,
            proj.owner, state.frameCount, proj.generation + 1,
          ),
        });
      }
      return { consume: true, spawns };
    }
    return null;
  },
});

// Fragment sub-weapon (not in lottery pool)
registerWeapon({
  id: 'buckshot_fragment',
  name: 'Fragment',
  description: '',
  tier: 'SUB',
  rarity: 'common',
  projectileRadius: 4,
  projectileSpeed: 0.55,
  color: 0xff8844,
  gravity: 0.18,
  bounces: 0,
  bounceEnergyRetention: 0.85,
  damage: 22,
  blastRadius: 55,
  knockbackMult: 0.09,
  knockbackRadius: 1.2,
  shakeIntensity: 3.0,
  particleScale: 0.8,
  craterShape: SMALL_CRATER,
});
